import { render } from "./Prefooter.vue?vue&type=template&id=66338ed7&ts=true"
import script from "./Prefooter.vue?vue&type=script&lang=ts"
export * from "./Prefooter.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__